import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {Button, Card, Form, Input, notification} from 'antd';

import {addRegulatoryBody} from './actions';
import {getDescriptionFromError} from "../utils/errors";
import {formItemLayout} from "../utils/style";
import {bindActionCreators} from "redux";

const FormItem = Form.Item;
const ButtonGroup = Button.Group;

function hasErrors(fieldsError) {
  return Object.keys(fieldsError).some(field => fieldsError[field]);
}

class AddRegulatoryBodyForm extends Component {
  static propTypes = {
    history: PropTypes.object.isRequired,
    loading: PropTypes.bool.isRequired,
    form: PropTypes.object.isRequired,
    addRegulatoryBody: PropTypes.func.isRequired,
  };

  goBack = () => {
    this.props.history.goBack();
  };

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFields(async(err, values) => {
      if (err) return;
      try {
        await this.props.addRegulatoryBody(values);
        this.goBack();
      } catch (err) {
        notification.error({
          message: 'Failed',
          description: getDescriptionFromError(err)
        });
      }
    });
  };

  render() {
    const {form: {getFieldDecorator, getFieldsError}, loading} = this.props;
    return (
      <Card title="Add Regulatory Body">
        <Form onSubmit={this.handleSubmit}>
          <FormItem
            {...formItemLayout}
            label="Name"
          >
            {getFieldDecorator('name', {
              rules: [{
                required: true,
                message: 'Name is required'
              }]
            })(
              <Input />
            )}
          </FormItem>
          <FormItem>
            <ButtonGroup>
              <Button
                type="primary"
                htmlType="submit"
                disabled={loading || hasErrors(getFieldsError())}
              >
                Add Regulatory Body
              </Button>
              <Button
                htmlType="button"
                onClick={this.goBack}
              >
                Cancel
              </Button>
            </ButtonGroup>
          </FormItem>
        </Form>
      </Card>
    );
  }
}

const AddRegulatoryBodyPage = Form.create()(AddRegulatoryBodyForm);

const mapStateToProps = state => ({
  loading: state.regulatoryBody.addingRegulatoryBody,
});

const mapDispatchToProps = dispatch => (bindActionCreators({
  addRegulatoryBody,
}, dispatch));

export default connect(mapStateToProps, mapDispatchToProps)(AddRegulatoryBodyPage);



// WEBPACK FOOTER //
// ./src/RegulatoryBody/AddRegulatoryBodyPage.js